import React from 'react';
import {useOutlet} from 'reconnect.js';
import {ConfigProvider} from 'antd';
import Theme from '../Theme';

export default function useArea(props) {
  const [area, setArea] = useOutlet('area');

  const initialArea = React.useCallback((props) => {
    let {pathname} = props.location ?? {};
    if (pathname.indexOf('/people') > -1) {
      console.log('setPeople');

      setArea('people');
      // it's violate csp style-src
      // ConfigProvider.config({
      //   theme: {
      //     primaryColor: '#f59000',
      //   },
      // });
      if (typeof document !== 'undefined') {
        document.body.style.setProperty('background-color', '#f59000');
      }
    } else if (pathname.indexOf('/doctor') > -1) {
      console.log('setDoctor');

      setArea('doctor');
      // it's violate csp style-src
      // ConfigProvider.config({
      //   theme: {
      //     primaryColor: '#2268c8',
      //   },
      // });
      if (typeof document !== 'undefined') {
        document.body.style.setProperty('background-color', '#17a98c');
      }
    }
  }, []);

  const isDoctorByPathname = React.useCallback((pathname) => {
    return pathname.indexOf('/doctor') > -1;
  }, []);

  return {
    area,
    isPeople: area === 'people',
    isDoctor: area === 'doctor',
    isDoctorByPathname,
    initialArea,
  };
}
